import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";
import Dropzone from "react-dropzone";
import { CentralContentWrapper, DropzoneContainer, MaxSizeDiv } from "./FileUploaderDropzone.styles";
import { FileUploaderStatus } from "./FileUploaderStatus";
import { UploadedFile } from "./UploadedFile";
import { useFileUploaderDropzoneState } from "./useFileUploaderDropzoneState";
export var FileUploaderDropzone = function FileUploaderDropzone(props) {
  var state = useFileUploaderDropzoneState(props);
  var currentFile = props.currentFile,
    loading = props.loading,
    onRemoveFile = props.onRemoveFile,
    showFileIcon = props.showFileIcon;
  if (state.showChosenFile) {
    return /*#__PURE__*/React.createElement(UploadedFile, {
      file: currentFile,
      onRemove: onRemoveFile
    });
  }
  return /*#__PURE__*/React.createElement(Dropzone, {
    accept: props.accepts,
    maxSize: props.maxFileSize,
    multiple: false,
    onDrop: state.handleDropResult
  }, function (_ref) {
    var getRootProps = _ref.getRootProps,
      getInputProps = _ref.getInputProps;
    return /*#__PURE__*/React.createElement(DropzoneContainer, {
      height: props.height,
      width: props.width,
      error: state.showUploadError ? state.showUploadError : undefined
    }, /*#__PURE__*/React.createElement(MaxSizeDiv, _objectSpread({}, getRootProps()), /*#__PURE__*/React.createElement("label", {
      htmlFor: "fileUploader",
      style: {
        display: "none"
      }
    }, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "zjDOpA",
      defaultMessage: [{
        "type": 0,
        "value": "Bestandsuploader"
      }]
    })), /*#__PURE__*/React.createElement("input", _objectSpread(_objectSpread({}, getInputProps()), {}, {
      id: "fileUploader"
    })), /*#__PURE__*/React.createElement(CentralContentWrapper, {
      color: state.iconColor
    }, /*#__PURE__*/React.createElement(FileUploaderStatus, {
      uploadCta: props.uploadCta,
      isLoading: loading,
      error: state.showUploadError,
      showFileIcon: showFileIcon
    }))));
  });
};